export function AutoRunIntro(startIntro: () => void, introName: string) {
    if (!HasBeenWatched()) {
        startIntro();
    }

    function HasBeenWatched(): boolean {
        return Boolean(window.SettingsManager.getAttribute(introName));
    }
}

export function introTemplateHeader(title: string, step: number, numberOfSteps: number) {
    return '<div class="introjs-tooltiptext-header mb-3"><div class="information">i</div><span class="introjs-tooltiptext-header-title">' + title + '</span><span class="introjs-tooltiptext-header-step">' + step + '/' + numberOfSteps + '</span></div>';
}

export function initFirstStepTemplateHeader($infoButtonSelector: JQuery, numberOfSteps: number) {
    $infoButtonSelector.attr('data-step', 1);
    $infoButtonSelector.attr('data-intro', introTemplateHeader('Információ gomb', 1, numberOfSteps) + 'Köszöntjük a megújult oldalon! A következőkben végig kalauzoljuk az újdonságokon. Ha nem szeretné most megnézni, kattintson a jobb felső sarokban található "X" gombra, a későbbiekben is bármikor megnézheti a bemutatót, erre a zöld i ikonra kattintva');
}

export function initLastStepTemplateHeader($lastElement: JQuery, lastStepId: number) {
    $lastElement.attr('data-step', lastStepId);
    $lastElement.attr('data-position', 'top');
    $lastElement.attr('data-intro', introTemplateHeader('Vége', lastStepId, lastStepId) + 'Köszönjük, hogy megnézte a bemutatót! Reméljük, hogy az új funkciók segítik a munkáját!');
}

export function initSingleStepTemplateHeader($lastElement: JQuery, lastStepId: number, title: string, text: string) {
    $lastElement.attr('data-step', lastStepId);
    $lastElement.attr('data-position', 'top');
    $lastElement.attr('data-intro', introTemplateHeader(title, lastStepId, lastStepId) + text);
}
